import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';
import isNull from 'lodash/isNull';
import intersection from 'lodash/intersection';

import {
  UPDATE_BASKET_FILTER,
  DASHBOARD_CLEAR_ALL_FILTERS,
  CLEAR_BASKET_FILTER,
} from 'actions/basketFilters';
import {
  VEGETARIAN,
  CALORIE_CONSCIOUS,
  CARB_CONSCIOUS,
  NOT_SPICY,
  MILD,
  MEDIUM,
  SPICY,
} from 'lib/constants';
import { toTitleCase } from 'utilities/strings';

export const COOK_TIME_FILTER = 'cookTimeFilter';
export const MEAL_TYPE_FILTER = 'mealTypeFilter';
export const DIET_PREF_FILTER = 'dietaryPreferenceFilter';
export const AVOIDANCE_FILTER = 'avoidanceFilter';
export const SPICE_LEVEL_FILTER = 'spiceLevelFilter';
export const PRIMARY_PROTEIN_FILTER = 'primaryProteinFilter';

export const mapFilterNames = {
  [COOK_TIME_FILTER]: 'Cook Time',
  [MEAL_TYPE_FILTER]: 'Meal Type',
  [DIET_PREF_FILTER]: 'Dietary Preferences',
  [AVOIDANCE_FILTER]: 'Dislikes',
  [SPICE_LEVEL_FILTER]: 'Spice Level',
  [PRIMARY_PROTEIN_FILTER]: 'Protein',
};
export const filterToDisplayName = {
  [CALORIE_CONSCIOUS]: 'Calorie Conscious',
  [CARB_CONSCIOUS]: 'Carb Conscious',
  [VEGETARIAN]: 'Vegetarian',
  beef: 'Beef',
  fish: 'Fish',
  milk: 'Milk',
  mushrooms: 'Mushrooms',
  peanuts: 'Peanuts',
  pork: 'Pork',
  poultry: 'Poultry',
  shellfish: 'Shellfish',
  soy: 'Soy',
  'tree nuts': 'Tree Nuts',
  wheat: 'Wheat',
  [NOT_SPICY]: NOT_SPICY,
  [MILD]: MILD,
  [MEDIUM]: MEDIUM,
  [SPICY]: SPICY,
};

export const initialState = {
  [COOK_TIME_FILTER]: null,
  [MEAL_TYPE_FILTER]: {},
  [DIET_PREF_FILTER]: {},
  [AVOIDANCE_FILTER]: {},
  [SPICE_LEVEL_FILTER]: {},
  [PRIMARY_PROTEIN_FILTER]: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_BASKET_FILTER:
      return {
        ...state,
        [action.filter]: action.value,
      };
    case CLEAR_BASKET_FILTER:
      return {
        ...state,
        [action.filter]: initialState[action.filter],
      };
    case DASHBOARD_CLEAR_ALL_FILTERS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const filterIsApplied = filter => {
  if (isObject(filter)) {
    return !isEmpty(filter);
  }
  return !isNull(filter);
};

export const selectTotalFiltersApplied = state => {
  let filterTotal = 0;
  Object.values(state).forEach(filterValue => {
    if (isObject(filterValue)) {
      filterTotal += Object.keys(filterValue).length;
    } else if (!isNull(filterValue)) {
      filterTotal += 1;
    }
  });
  return filterTotal;
};

export const selectFilterLabel = (state, filter) => {
  const selectedFilter = state[filter];
  if (isObject(selectedFilter)) {
    const filters = Object.keys(selectedFilter);
    if (filters.length === 1) {
      const filterValue = filters[0];
      return filterToDisplayName[filterValue] || toTitleCase(filterValue);
    } else if (filters.length > 1) {
      return `${mapFilterNames[filter]} · ${filters.length}`;
    }
  } else if (!isNull(selectedFilter)) {
    if (filter === COOK_TIME_FILTER) {
      return `${selectedFilter} Min`;
    }
  }
  return mapFilterNames[filter];
};

export const selectBasketFilter = (state, filter) => state[filter];

const checkCookTimeFilter = (meal, filter) => {
  const maxCookTime = Number(meal.maxCookTime);

  if (isNaN(maxCookTime)) return false;
  else {
    return maxCookTime <= Number(filter);
  }
};

const checkFilter = (meal, filter, filterName) => {
  switch (filterName) {
    case MEAL_TYPE_FILTER:
      return filter[meal.primaryLabel] === true;
    case PRIMARY_PROTEIN_FILTER:
      return intersection(meal.primaryProteinNames, Object.keys(filter)).length > 0;
    case DIET_PREF_FILTER:
      return intersection(meal.tags, Object.keys(filter)).length > 0;
    case AVOIDANCE_FILTER:
      return intersection(meal.avoidances, Object.keys(filter)).length === 0;
    case SPICE_LEVEL_FILTER:
      return filter[meal.spiceLevel] === true;
    default:
      return false;
  }
};

export const checkMealFilters = (meal, filters) => {
  let mealIsInFilterGroup = true;

  if (filters[COOK_TIME_FILTER]) {
    mealIsInFilterGroup = checkCookTimeFilter(meal, filters[COOK_TIME_FILTER]);
  }

  [
    MEAL_TYPE_FILTER,
    PRIMARY_PROTEIN_FILTER,
    DIET_PREF_FILTER,
    AVOIDANCE_FILTER,
    SPICE_LEVEL_FILTER,
  ].forEach(filterName => {
    if (mealIsInFilterGroup === true) {
      if (filters[filterName] && !isEmpty(filters[filterName])) {
        mealIsInFilterGroup = checkFilter(meal, filters[filterName], filterName);
      }
    }
  });

  return mealIsInFilterGroup;
};
